<template>
  <div class="auto-storage-container">
    <div class="store-search-container">
      <el-form :inline="true">
        <el-form-item label="产品">
          <el-select v-model="query.productName" filterable placeholder="请选择产品" style="width: 300px;" @change="handlerProductChange">
            <el-option v-for="item in products" :key="item.sampleName" :label="item.sampleName" :value="item.sampleName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="页码" style="margin-left: 30px;">
          <!--<el-input v-model="pageCodes" placeholder="请输入页码，多页码使用英文“,”逗号分割" style="width: 300px;"></el-input>-->
          <el-select v-model="query.pageCode" multiple placeholder="页码" filterable clearable style="width: 300px;" @change="handlerPageChange">
            <el-option v-for="item in pageCodes" :key="item.value" :label="item.value" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="品番" style="margin-left: 30px;">
          <el-select v-model="query.designation" multiple placeholder="品番" filterable clearable style="width: 300px;">
            <el-option v-for="(item, index) in designations" :key="index" :label="item.merchandiseNumber" :value="item.merchandiseNumber"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分期" style="margin-left: 30px;">
          <el-select v-model="query.fenqi" multiple placeholder="分期" filterable clearable style="width: 300px;">
            <el-option v-for="(item, index) in fenqiDatas" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handlerQueryLocation">查询</el-button>
          <el-button type="warning" @click="handlerClear">清空</el-button>
          <el-button type="success" @click="handlerRefresh">刷新</el-button>
          <el-button type="info" @click="handlerPrint">打印</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="store-main-container" style="background: #fff;">
      <div style="width: 1418px; height: 2000px;"></div>
      <!------- 大区域 ------->
      <div class="area" style="top: 852px;">
        <!-- A区开始 -->
        <div class="location-container-group">
          <div class="location-container" style="width: 51px; border-right: 1px dotted #333;">
            <div v-for="(item, index) in numArr_7_13" :key="index" class="location" :id="'A' + item + '-2'">{{'A' + item + '-2'}}</div>
          </div>
          <div class="location-container">
            <div v-for="(item, index) in numArr_7_13" :key="index" class="location" :id="'A' + item + '-1'">{{'A' + item + '-1'}}</div>
          </div>
          <div class="fireCock"></div>
          <div class="location-container" style="width: 51px; border-right: 1px dotted #333;">
            <div v-for="(item, index) in numArr_1_5" :key="index" class="location" :id="'A' + item + '-2'">{{'A' + item + '-2'}}</div>
          </div>
          <div class="location-container">
            <div v-for="(item, index) in numArr_1_5" :key="index" class="location" :id="'A' + item + '-1'">{{'A' + item + '-1'}}</div>
          </div>
          <!-- <div class="advisement-player"></div> -->
          <div class="location-top-bom">
            <div></div>
            <div></div>
          </div>
          <div class="location-name">A区</div>
        </div>
        <!-- A区结束 -->
        <div class="channel"></div>
        <!-- B区开始 -->
        <div class="location-container-group">
          <div class="location-container" style="width: 51px; border-right: 1px dotted #333;">
            <div v-for="(item, index) in numArr_1_13" :key="index" class="location" :id="'B' + item + '-2'">{{'B' + item + '-2'}}</div>
          </div>
          <div class="location-container">
            <div v-for="(item, index) in numArr_1_13" :key="index" class="location" :id="'B' + item + '-1'">{{'B' + item + '-1'}}</div>
          </div>
          <div class="location-top-bom">
            <div></div>
            <div></div>
          </div>
          <div class="location-name">B区</div>
        </div>
        <!-- B区结束 -->
        <!-- C区开始 -->
        <div class="location-container-group" style="margin-left:-2px;">
          <div class="location-container" style="width: 51px; border-right: 1px dotted #333;">
            <div v-for="(item, index) in numArr_1_13" :key="index" class="location" :id="'C' + item + '-2'">{{'C' + item + '-2'}}</div>
          </div>
          <div class="location-container">
            <div v-for="(item, index) in numArr_1_13" :key="index" class="location" :id="'C' + item + '-1'">{{'C' + item + '-1'}}</div>
          </div>
          <div class="location-top-bom">
            <div></div>
            <div></div>
          </div>
          <div class="location-name">C区</div>
        </div>
        <!-- C区结束 -->
        <div class="channel"></div>
        <!-- D区开始 -->
        <div class="location-container-group">
          <div class="location-container" style="width: 51px; border-right: 1px dotted #333;">
            <div v-for="(item, index) in numArr_1_13" :key="index" class="location" :id="'D' + item + '-2'">{{'D' + item + '-2'}}</div>
          </div>
          <div class="location-container">
            <div v-for="(item, index) in numArr_1_13" :key="index" class="location" :id="'D' + item + '-1'">{{'D' + item + '-1'}}</div>
          </div>
          <div class="location-top-bom">
            <div></div>
            <div></div>
          </div>
          <div class="location-name">D区</div>
        </div>
        <!-- D区结束 -->
        <!-- E区开始 -->
        <div class="location-container-group" style="margin-left:-2px;">
          <div class="location-container" style="width: 51px; border-right: 1px dotted #333;">
            <div v-for="(item, index) in numArr_1_13" :key="index" class="location" :id="'E' + item + '-2'">{{'E' + item + '-2'}}</div>
          </div>
          <div class="location-container">
            <div v-for="(item, index) in numArr_1_13" :key="index" class="location" :id="'E' + item + '-1'">{{'E' + item + '-1'}}</div>
          </div>
          <div class="location-top-bom">
            <div></div>
            <div></div>
          </div>
          <div class="location-name">E区</div>
        </div>
        <!-- E区结束 -->
      </div>

      <!------- 大区域 ------->
      <div class="area" style="top: 201px; left: 669px">
        <!-- F区开始 -->
        <div class="location-container-group">
          <div class="location-container" style="width: 51px; border-right: 1px dotted #333;">
            <div v-for="(item, index) in numArr_1_13" :key="index" class="location" :id="'F' + item + '-2'">{{'F' + item + '-2'}}</div>
          </div>
          <div class="location-container">
            <div v-for="(item, index) in numArr_1_13" :key="index" class="location" :id="'F' + item + '-1'">{{'F' + item + '-1'}}</div>
          </div>
          <div class="location-top-bom">
            <div></div>
            <div></div>
          </div>
          <div class="location-name">F区</div>
        </div>
        <!-- F区结束 -->
        <div class="channel"></div>
        <!-- G区开始 -->
        <div class="location-container-group">
          <div class="location-container" style="width: 51px; border-right: 1px dotted #333;">
            <div v-for="(item, index) in numArr_1_13" :key="index" class="location" :id="'G' + item + '-2'">{{'G' + item + '-2'}}</div>
          </div>
          <div class="location-container">
            <div v-for="(item, index) in numArr_1_13" :key="index" class="location" :id="'G' + item + '-1'">{{'G' + item + '-1'}}</div>
          </div>
          <div class="location-top-bom">
            <div></div>
            <div></div>
          </div>
          <div class="location-name">G区</div>
        </div>
        <!-- G区结束 -->
        <!-- H区开始 -->
        <div class="location-container-group" style="margin-left:-2px;">
          <div class="location-container" style="width: 51px; border-right: 1px dotted #333;">
            <div v-for="(item, index) in numArr_1_13" :key="index" class="location" :id="'H' + item + '-2'">{{'H' + item + '-2'}}</div>
          </div>
          <div class="location-container">
            <div v-for="(item, index) in numArr_1_13" :key="index" class="location" :id="'H' + item + '-1'">{{'H' + item + '-1'}}</div>
          </div>
          <div class="location-top-bom">
            <div></div>
            <div></div>
          </div>
          <div class="location-name">H区</div>
        </div>
        <!-- H区结束 -->
        <div class="channel"></div>
        <!-- I区开始 -->
        <div class="location-container-group">
          <div class="location-container" style="width: 51px; border-right: 1px dotted #333;">
            <div v-for="(item, index) in numArr_1_13" :key="index" class="location" :id="'I' + item + '-2'">{{'I' + item + '-2'}}</div>
          </div>
          <div class="location-container">
            <div v-for="(item, index) in numArr_1_13" :key="index" class="location" :id="'I' + item + '-1'">{{'I' + item + '-1'}}</div>
          </div>
          <div class="location-top-bom">
            <div></div>
            <div></div>
          </div>
          <div class="location-name">I区</div>
        </div>
        <!-- I区结束 -->
        <!-- J区开始 -->
        <div class="location-container-group" style="margin-left:-2px;">
          <div class="location-container" style="width: 51px; border-right: 1px dotted #333;">
            <div v-for="(item, index) in numArr_1_13" :key="index" class="location" :id="'J' + item + '-2'">{{'J' + item + '-2'}}</div>
          </div>
          <div class="location-container">
            <div v-for="(item, index) in numArr_1_13" :key="index" class="location" :id="'J' + item + '-1'">{{'J' + item + '-1'}}</div>
          </div>
          <div class="location-top-bom">
            <div></div>
            <div></div>
          </div>
          <div class="location-name">J区</div>
        </div>
        <!-- J区结束 -->
      </div>

      <!------- 大区域 ------->
      <div class="area" style="top: 1000px; left: 1185px;">
        <!-- K区开始 -->
        <div class="location-container-group" style="border-bottom: 1px solid #333;">
          <div class="location-name" style="border-top: 0; border-bottom: 1px solid #333;">K区</div>
          <div class="location-top-bom">
            <div></div>
            <div></div>
          </div>
          <div class="location-container" style="width: 51px; border-right: 1px dotted #333;">
            <div v-for="(item, index) in numArr_1_17" :key="index" class="location" :id="'K' + item + '-2'">{{'K' + item + '-2'}}</div>
          </div>
          <div class="location-container">
            <div v-for="(item, index) in numArr_1_17" :key="index" class="location" :id="'K' + item + '-1'">{{'K' + item + '-1'}}</div>
          </div>
        </div>
        <!-- K区结束 -->
      </div>

      <div class="channel" style="position: absolute; top: 201px; left: 1290px; height: 1754px; border-top: 2px solid #333;"></div>

      <!------- 大区域 ------->
      <div class="area" style="top: 0px; left: 1340px;">
        <!-- K区开始 -->
        <div class="location-container-group" style="border-bottom: 1px solid #333;">
          <!-- <div class="location-name" style="border-top: 0; border-bottom: 1px solid #333;">L区</div>
          <div class="location-top-bom">
            <div></div>
            <div></div>
          </div> -->
          <div class="location-container" style="width: 51px; border-right: 1px dotted #333;">
            <div v-for="(item, index) in numArr_1_39" :key="index" class="location" :id="'L' + item + '-2'">{{'L' + item + '-2'}}</div>
          </div>
          <div class="location-container">
            <div v-for="(item, index) in numArr_1_39" :key="index" class="location" :id="'L' + item + '-1'">{{'L' + item + '-1'}}</div>
          </div>
        </div>
        <!-- K区结束 -->
      </div>

      <div style="display: flex; position: absolute; top: 1501px; left: 835px; width: 350px; height: 450px; border: 1px solid #666; border-right: 0; border-bottom: 0; text-align: center; flex-direction: column; justify-content: center; font-size: 18px;">电梯</div>
      <div style="display: flex; position: absolute; top: 1604px; left: 1px; width: 50px; height: 348px; border-top: 2px solid #333; border-right: 1px solid #666; text-align: center; flex-direction: column; justify-content: center; font-size: 12px;">入口</div>
      <div style="position: absolute; width: 1400px; top: 1951px; left: 0; border: 1px solid #333;"></div>
    </div>
    <div id="print_area" style="position: relative; z-index: -1; text-align:center; ">
      <table
        border="1px solid #000"
        cellspacing="0"
        style="table-layout: fixed"
      >
        <thead>
          <tr>
            <th style="width:50px">序号</th>
            <th style="width:200px">品名</th>
            <th style="width:70px">页码</th>
            <th style="width:70px">品番</th>
            <th style="width:70px">包数</th>
            <th style="width:70px">每包数</th>
            <th style="width:70px">总数</th>
            <th style="width:70px">笼号</th>
            <th style="width:70px">库位</th>
          </tr>
        </thead>
        <tr v-for="(itemSub, indexSub) in materialPackageCollectionDetailAndLocation" :key="indexSub">
          <td style="text-align: center;">{{ indexSub + 1 }}</td>
          <td style="text-align: center;">{{ itemSub.sampleName }}</td>
          <td style="text-align: center;">{{ itemSub.pageCount }}</td>
          <td style="text-align: center;">{{ itemSub.merchandiseNumber }}</td>
          <td style="text-align: center;">{{ itemSub.bagNum }}</td>
          <td style="text-align: center;">{{ itemSub.packageNum }}</td>
          <td style="text-align: center;">{{ itemSub.productOutput }}</td>
          <td style="text-align: center;">{{ itemSub.basketNo }}</td>
          <td style="text-align: center;">{{ itemSub.locationNo }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      query: {
        storageCategory: 'auto',
        // productId: '',
        productName: '',
        // 产品编号
        productCode: '',
        // 页码
        pageCode: [],
        // 番号
        designation: [],
        //分期
        fenqi:[]
      },
      materialPackageCollectionDetailAndLocation: [],
      products: [],
      pageCodes: [],
      designations: [],
      numArr_1_5: [],
      numArr_7_13: [],
      numArr_1_13: [],
      numArr_1_17: [],
      numArr_1_39: [],
      fenqiDatas:[{label:'前期',value:'0'},{label:'中期',value:'1'},{label:'后期',value:'2'},{label:'无限制',value:'3'}]
    }
  },
  created: function () {
  },
  mounted: function () {
    for (let i = 1; i <= 39; ++i) {
      this.numArr_1_39.push(i.toString())

      if (i <= 13) {
        this.numArr_1_13.push(i.toString())
        this.numArr_1_17.push(i.toString())
        if (i <= 5) {
          this.numArr_1_5.push(i.toString())
        }
        if (i >= 7) {
          this.numArr_7_13.push(i.toString())
        }
      }
      if (i > 13 && i <= 17) {
        this.numArr_1_17.push(i.toString())
      }
    }
    this.loadData()
  },
  methods: {
    // 加载数据
    loadData: function () {
      const _this = this
      _this.post(_this.$apis.getStoreProducts, {}, function (res) {
        const _json = res.data
        _this.products = _json.products
        _this.handlerQueryLocation()
      })
    },
    handlerClear: function () {
      this.query = {
        storageCategory: 'second',
        // 产品Id
        // productId: '',
        productName: '',
        // 页码
        pageCode: [],
        // 番号
        designation: []
      }
      if (this.isSearched) {
        this.handlerQueryLocation()
        this.pageCodes = []
        this.designations = []
      }
    },
    // 刷新事件
    handlerRefresh: function () {
      this.loadData()
      if (this.isSearched) {
        this.handlerQueryLocation()
      }
    },
    /*
    handlerGetPageCode: function () {
      const _this = this
      // ajax提交至服务器，删除数据
      _this.post(_this.$apis.getStorePageCodes, { productId: _this.query.productId }, function (res) {
        let _json = res.data
        _this.pageCodes = _json.pageCodes
        _this.designations = _json.designations
      })
    },
    */
    handlerProductChange: function () {
      const _this = this
      // ajax提交至服务器，删除数据
      _this.post(_this.$apis.getStorePageCodes, this.query, function (res) {
        let _json = res.data
        _this.pageCodes = _json.pageCodes
        _this.designations = _json.designations
      })
    },
    handlerPageChange: function (val) {
      const _this = this
      _this.query.designation = []
      // ajax提交至服务器，删除数据
      _this.post(_this.$apis.getDesignations, this.query, function (res) {
        let _json = res.data
        _this.designations = _json.designations
      })
    },
    // 根据产品名称、页码、番号，获取对应的库位
    handlerQueryLocation: function () {
      const _this = this
      // _this.pageCodes = _this.pageCodes.replaceAll('，', ',')
      // _this.query.pageCode = _this.pageCodes.split(',')
      let allLocations = document.getElementsByClassName('location')
      for (let i = 0; i < allLocations.length; ++i) {
        allLocations[i].className = 'location'
      }
      let locationNumbers = []
      _this.post(_this.$apis.getStorageLocations, _this.query, function (res) {
        const _json = res.data
        console.log(_json)
        _this.materialPackageCollectionDetailAndLocation = _json.materialPackageCollectionDetailAndLocation
        // 获取到的库位号
        locationNumbers = _json.storageLocations
        if (locationNumbers.length > 0) {
          for (let i = 0; i < locationNumbers.length; ++i) {
            let storage = locationNumbers[i]
            let domTd = document.getElementById(storage.locationNo)
            if (domTd) {
              domTd.className = 'location ' + storage.type
            }
          }
          _this.isSearched = true
        } else {
          _this.isSearched = false
        }
      })
    },
    handlerPrint: function () {
      const style =
            '@page { margin-top: 50px } @media print { h1 { color: blue } img {margin: 0 auto;}}'
      this.$print({
        printable: 'print_area',
        type: 'html',
        style: style,
        scanStyles: false
      })
    }
  },
  components: {
  }
}
</script>

<style scoped>
  div {
    box-sizing: border-box;
    font-size: 14px;
  }
  .store-search-container {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    background-color: #fff;
    padding: 5px 0;
    height: 50px;
    z-index: 1000;
    box-shadow: 0px 1px 5px #ccc;
  }
  .store-main-container {
    position: fixed;
    top: 50px;
    right: 32px;
    bottom: 0;
    left: 0px;
    padding-left: 50px;
    overflow: auto;
  }
  .area {
    position: absolute;
    display: flex;
    top: 0;
    border-top: 2px solid #333;
  }
  .location-container-group {
    display: flex;
    width: 105px;
    flex-wrap: wrap;
    border: 2px solid #333;
    border-top: 0;
  }
  .location-container {
    width: 50px;
    display: flex;
    flex-direction: column-reverse;
  }
  .location {
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    border-bottom: 1px solid #333;
    box-sizing: border-box;
    background: #FFF;
  }
  .location.hasGoods {
    background-color: #DAEEF3;
    cursor: pointer;
  }
  .location.current {
    background-color: #a00;
    color: #fff;
    cursor: pointer;
  }
  .advisement-player {
    width: 101px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background: #FF0;
    color: #F00;
    border-bottom: 1px solid #333;
  }
  .advisement-player::before {
    content: '显示屏';
  }
  .location-top-bom {
    display: flex;
    width: 100px;
    height: 25px;
  }
  .location-top-bom > div {
    width: 51px;
    line-height: 25px;
    text-align: center;
    border-right: 1px dotted #333;
  }
  .location-top-bom > div::before {
    content: '上'
  }
  .location-top-bom > div:last-child {
    width: 50px;
    border-right: 0;
  }
  .location-top-bom > div:last-child::before {
    content: '下'
  }
  .location-name {
    width: 101px;
    height: 75px;
    line-height: 75px;
    text-align: center;
    border-top: 1px solid #333;
  }
  .channel {
    display: flex;
    flex-direction: column;
    width: 50px;
    text-align: center;
    justify-content: center;
  }
  .channel::before {
    content: '通道'
  }
  .fireCock {
    width: 101px;
    height: 50px;
    line-height: 50px;
    background: #0a0;
    border-bottom: 1px solid #333;
    color: #fff;
  }
  .fireCock::before {
    content: '消火栓'
  }
</style>
